"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { noterNavigation } from "@/lib/historique-navigation";

/**
 * Enregistre le chemin courant à chaque navigation, sans rien afficher.
 *
 * ⚠️ Monté dans le gabarit RACINE, pas dans celui du site : il doit tourner sur
 * `/certification` aussi, qui vit hors du gabarit du site. Sinon la page de
 * certification serait le seul endroit où le suivi ne s'exécute pas, c'est-à-dire
 * précisément là où on s'en sert.
 */
export function SuiviNavigation() {
  const chemin = usePathname();

  useEffect(() => {
    noterNavigation(chemin);
  }, [chemin]);

  return null;
}
